export default "__VITE_ASSET__Bsk752sH__"